<template>
    <div class="page course-detail">
        <column-skeleton v-if="loading" style="margin-bottom: 100vh"></column-skeleton>

        <video
            id="my-video"
            class="video-js vjs-default-skin vjs-big-play-centered"
            controls
            preload="none"
            x5-playsinline=""
            webkit-playsinline=""
            playsinline=""
            :poster="course.cover_img"
            x-webkit-airplay="true"
        ></video>

        <div class="course-detail-header">
            <div class="header-title">{{ course.title }}</div>
            <div class="header-view">
                <div class="header-time-long">{{ course.created_at }} | {{ Duration }}分钟</div>
                <div class="header-view-count">
                    <div class="header-view-count-text">{{ course.view_count }}人学习</div>
                    <div class="header-view-count-images">
                        <img :src="item" alt="" v-for="(item, index) in course.last_study_user_avatar" :key="index" />
                    </div>
                </div>
                <div class="clear"></div>
            </div>
        </div>

        <!-- 专家信息 start-->
        <ExpertInfo :acceptData="course.professors" />
        <!-- 专家信息 end -->

        <div class="course-detail-content">
            <div class="rich_media_inner" v-html="course.content"></div>
        </div>

        <div class="comment">
            <div class="comment-title">评论</div>
            <div class="comment-section" v-for="item in comment" :key="item.id">
                <div class="comment-section-photo">
                    <img :src="item.avatar" alt="" />
                </div>
                <div class="comment-section-content">
                    <div class="comment-section-content-author" @click="reComment(item)">{{ item.nickname }}</div>
                    <div class="comment-section-content-detail" @click="reComment(item)" v-html="item.content.replace(/\\x(\d{1,2})/g,'<img style=\'width:22px\' src=&quot;https://static.mudu.tv/assets/img-console/activity/face/$1.png&quot; />')"></div>
                    <div class="comment-section-content-bottom">
                        <div class="comment-section-content-time">{{ item.created_at }}</div>
                        <div class="comment-section-content-point" @click="pointLikeComment(item)">
                            <span v-if="item.isLike"
                                ><van-icon name="/static/img/course/icon_course_like_on.svg"
                            /></span>
                            <span v-else><van-icon name="/static/img/course/icon_course_like_off.svg"/></span>
                            {{ item.like_count == 0 ? '赞' : item.like_count }}
                        </div>
                        <div class="clear"></div>
                        <div
                            class="comment-section-content-children"
                            v-if="item.children != null && item.children.length > 0"
                        >
                            <div v-for="(val, valIndex) in item.children" :key="valIndex">
                                <span @click="reCommentChild(val)">{{ val.name }}</span>
                                <span style="color: #404040" v-if="val.reply_name != ''"> 回复 </span>
                                <span @click="reCommentChild(val)">{{ val.reply_name }}</span>
                                ：<span v-html="val.content.replace(/\\x(\d{1,2})/g,'<img src=&quot;https://static.mudu.tv/assets/img-console/activity/face/$1.png&quot; />')"></span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="clear"></div>
            </div>
            <div class="clear"></div>
        </div>

        <!-- 新内容 start-->
        <div class="new-live-detail-home-footer" v-if="tab !== 2">
            <div
                class="new-live-detail-home-footer-content-text"
                v-if="course && course.parent && course.parent.title"
                @click="goParent(course.parent)"
            >
                <van-image fit="cover" src="/static/bytx/detail_tag_column_icon.svg"></van-image>
                <div>
                    {{ course.parent.title }}
                </div>
                <div><van-icon name="arrow" /></div>
            </div>
            <div class="new-live-detail-home-footer-bottom">
                <div class="new-live-detail-home-footer-bottom-left">
                    <van-grid :column-num="1" :border="false">
                        <van-grid-item
                            icon="/static/img/live/icon_live_meme.svg"
                            @click="showActionMeme = !showActionMeme"
                        />
                    </van-grid>
                </div>
                <div :class="['new-live-detail-home-footer-bottom-center ', comment_text != '' ? 'comment_in' : '']">
                    <van-field
                        round
                        left-icon="/static/img/course/icon_course_text.svg"
                        v-model="comment_text"
                        :placeholder="comment_placeholder == '' ? '写评论…' : comment_placeholder"
                    >
                    </van-field>
                </div>
                <div class="new-live-detail-home-footer-bottom-right">
                    <van-grid :column-num="3" :border="false" v-if="comment_text == ''">
                        <div v-if="is_manager">
                            <van-grid-item
                                @click="favorite()"
                                v-if="course.isFavorite"
                                icon="/static/img/course/icon_course_favorite_on_20.svg"
                                text="已收藏"
                            />
                            <van-grid-item @click="favorite()" v-else icon="/static/bytx/collection.svg" text="收藏" />
                        </div>
                        <van-grid-item @click="showDialog" icon="/static/bytx/Inquiries.svg" text="去问诊" />
                        <van-grid-item @click="goWechat()" icon="/static/bytx/customer-service.svg" text="客服" />
                        <div v-if="!is_manager">
                            <van-grid-item
                                class="more-actions"
                                icon="/static/img/live/icon_live_more.svg"
                                @click="showAction = !showAction"
                            />
                        </div>
                    </van-grid>

                    <div class="live-detail-home-footer-right-btn" v-if="comment_text">
                        <van-button
                            type="danger"
                            size="medium"
                            color="#0FB7AD"
                            style="width:100%"
                            @click="createComment"
                            round
                        >
                            发送
                        </van-button>
                    </div>
                </div>
            </div>
            <div class="live-detail-home-footer-bottom" v-if="showAction">
                <van-divider />
                <van-grid :column-num="is_manager ? 3 : 2" :border="false">
                    <van-grid-item
                        icon="/static/img/course/icon_course_download.svg"
                        text="资料下载"
                        @click="showDownload = true"
                    />
                    <van-grid-item
                        @click="favorite()"
                        v-if="course.isFavorite"
                        icon="/static/img/course/icon_course_favorite_on_20.svg"
                        text="已收藏"
                    />
                    <van-grid-item
                        @click="favorite()"
                        v-else
                        icon="/static/img/course/icon_course_favorite_off_20.svg"
                        text="收藏"
                    />
                    <van-grid-item text="发送图片" v-if="is_manager">
                        <template slot="icon">
                            <van-uploader :after-read="afterRead" accept="*">
                                <img
                                    width="20"
                                    style="margin-bottom: 5px;margin-top: 3px"
                                    src="https://dr-yyh.com/static/two/upload_img.svg"
                                    alt=""
                                />
                            </van-uploader>
                        </template>
                    </van-grid-item>
                </van-grid>
                <van-divider />
                <van-number-keyboard safe-area-inset-bottom />
            </div>
            <div class="live-detail-home-footer-bottom" v-if="showActionMeme">
                <van-divider />
                <van-grid :column-num="10" :border="false">
                    <van-grid-item
                        @click="choose_meme(index)"
                        :icon="'http://static.mudu.tv/assets/img-console/activity/face/' + index + '.png'"
                        v-for="index in 75"
                        :key="index"
                    />
                </van-grid>
                <van-divider />
                <van-number-keyboard safe-area-inset-bottom />
            </div>
        </div>
        <!-- 新内容 ent -->

        <van-overlay :show="showShareDialog" @click="showShareDialog = false">
            <div class="share-box">
                <div class="block">请点击 “...”，再点击发送给朋友 | <span>知道啦</span></div>
                <div class="share-box-bottom">
                    <img src="/static/bytx/detail_forward_2_img.png" alt="" />
                </div>
            </div>
        </van-overlay>

        <van-action-sheet v-model="showDownload" title="资料下载">
            <div class="download-cell">
                <van-cell
                    title-class="download-cell__item"
                    v-for="item in course.downloads"
                    :key="item.link"
                    :title="item.name"
                    :url="item.link"
                    :icon="
                        item.type == 'pdf'
                            ? '/static/img/course/icon_course_download_pdf.svg'
                            : '/static/img/course/icon_course_download_pic.svg'
                    "
                    icon-size="20px"
                >
                    <template slot="right-icon">
                        <van-icon name="/static/img/course/icon_course_download.svg" />
                    </template>
                </van-cell>
            </div>
            <div class="van-action-sheet__footer" style="height: 30px">
                <div class="van-action-sheet__gap"></div>
            </div>
        </van-action-sheet>

        <van-dialog class="content" v-model="needPassword" :show-confirm-button="false">
            <template slot="title">
                本视频需要您输入观看密码
            </template>
            <div class="cancel_otp_code_box">
                <div class="otpInputs">
                    <input
                        v-enterfocus
                        ref="otpInputs"
                        type="number"
                        value="12"
                        v-model="code"
                        @keydown.delete="changeCode"
                    />
                    <span class="code_list">{{ code1 }}</span>
                    <span class="code_list">{{ code2 }}</span>
                    <span class="code_list">{{ code3 }}</span>
                    <span class="code_list last_code_list">{{ code4 }}</span>
                </div>
                <p class="error_text" :class="{ show: error }">密码错误请重试</p>
            </div>
            <div class="content-footer">
                <van-button style="width: 50%" type="danger" round @click="checkPassword(3)" color="#D3172E">
                    点击验证
                </van-button>
            </div>
        </van-dialog>
    </div>
</template>

<script>
import Interface from '@/util/interface'
import videojs from 'video.js'
import columnSkeleton from '@/skeleton/columnSkeleton'
import verify from '../../../mixins/verify'
import checkLogin from '../../../mixins/checkLogin'
import ExpertInfo from '@/components/expertInfo'
import {LocationHref} from '@/util/common'

export default {
    name: 'course-detail',
    mixins: [verify, checkLogin],
    components: {
        'column-skeleton': columnSkeleton,
        ExpertInfo
    },
    data() {
        return {
            id: '',
            course: {},
            comment: [],
            downloads: [],
            related: [],
            value: '',
            active: '',
            tab: 0,
            comment_text: '',
            course_img_visible: true,
            loading: true,
            share_data: {},
            showShareDialog: false,
            htmlUrl: '',
            isShow: false,
            status: '',
            showDownload: false,
            myPlayer: '',
            comment_id: 0,
            to_user_id: 0,
            comment_placeholder: '写评论',
            user_id: 0,
            content_type: 0,
            Duration: 0,
            showAction: false,
            showActionMeme: false,
            showActionScribe: false,
            is_manager: true,
            is_show:false,
        }
    },
    methods: {
        goParent(row) {
            this.$router.push({ name: 'video-column', params: { id: row.id } })
        },
        choose_meme(index) {
            this.comment_text += index < 10 ? '\\x' + index : '\\x' + index
        },
        goWechat() {
            LocationHref('https://work.weixin.qq.com/kfid/kfc80e2e65a20c7e4b8')
        },
        showDialog() {
            this.$refs.Refconsult.overlayShow = true
        },
        fetch(scene) {
            if (scene === 'course') {
                Interface.getData('get', Interface.short_video.detail + '/' + this.id).then(res => {
                    this.course = res.data
                  if(this.course.need_auth == 1){
                    this.addInfo("video")
                  }
                    this.course.course_time = new Date(this.course.created_at.replace(/-/g, '\/'))
                    document.title = this.course.title
                    if (this.course) {
                        if (this.course.need_password === 1 && !this.course.isPasswordAuth) {
                            this.needPassword = true
                        }
                        Interface.getShareInfo(this, this.course.title, this.course.cover_img, '')
                    }
                    Interface.getData('get', Interface.video_info + '/' + res.data.video_id).then(resp => {
                        let videoUrl

                        this.Duration = Math.ceil(resp.data.VideoBase.Duration / 60)

                        resp.data.PlayInfoList.PlayInfo.forEach(val => {
                            if (val.Format == 'mp4') {
                                videoUrl = val.PlayURL
                            }
                        })
                        const myPlayerOptions = {
                            bigPlayButton: true,
                            textTrackDisplay: true,
                            posterImage: true,
                            errorDisplay: true,
                            controlBar: true,
                            autoplay: false,
                            controls: true
                        }
                        this.course_img_visible = false
                        setTimeout(() => {
                            let _this = this
                            this.myPlayer = videojs('my-video', myPlayerOptions, function onPlayerReady() {
                                this.on('play', function() {
                                    //检测登录
                                    let user = localStorage.getItem('user')
                                    user = JSON.parse(user)
                                    if (_this.course.need_auth === 1 && user.new_reg_complete !== 1) {
                                        setTimeout(() => {
                                            this.pause()
                                            _this.showAddConfirm("video")
                                        }, 10000)
                                    }
                                })
                            })
                            this.myPlayer.src(videoUrl)
                            this.myPlayer.load(videoUrl)
                            setTimeout(() => {
                                this.loading = false
                            }, 500)
                        }, 500)
                    })
                    if (this.course.downloads != null && this.course.downloads.length > 0) {
                        this.course.downloads.forEach(item => {
                            if (item.link) {
                                item.type = item.link.substr(item.link.length - 3, 3)
                            }
                        })
                    } else {
                        this.course.downloads = []
                    }
                })
            } else if (scene === 'comment') {
                let params = {
                    content_id: this.id,
                    comment_type: 3,
                    content_type: this.content_type,
                    page: 1,
                    pageSize: 999
                }
                Interface.getData('get', Interface.course.comment.list, params).then(res => {
                    if (res.code == 0 && res.data.list != null) {
                        this.comment = res.data.list
                    }
                })
            } else if (scene === 'footprint') {
                let params = {
                    id: this.id,
                    type: 3,
                    content_type: this.content_type
                }
                Interface.getData('post', Interface.footprint, params).then(res => {})
            } else if (scene === 'share') {
                let params = {
                    content_id: this.id,
                    type: 3
                }
                Interface.getData('get', Interface.share, params).then(res => {
                    this.share_data = res.data
                    this.htmlUrl = res.data.post_img_url
                })
            }
        },
        reComment(item) {
            this.comment_placeholder = '回复' + item.nickname
            this.comment_id = item.id
        },
        reCommentChild(item) {
            this.comment_placeholder = '回复' + item.nickname
            this.comment_id = item.comment_id
            this.to_user_id = item.user_id
        },
        favorite() {
            let params = {
                content_type: this.content_type
            }
            Interface.getData('get', Interface.short_video.favorite + this.id, params).then(res => {
                if (res.code == 0) {
                    this.course.isFavorite = !this.course.isFavorite
                }
            })
        },
        goComment() {
            this.tab = 1
        },
        createComment() {
            if (!this.userLoginCheck()) {
                return
            }
            this.tab = 1
            if (this.comment_text == '') {
                return
            }
            let params = {
                content_id: this.id,
                comment_type: 3,
                content: this.comment_text,
                content_type: this.content_type
            }
            if (this.comment_id != 0) {
                params.comment_id = +this.comment_id
            }
            if (this.to_user_id != 0) {
                params.to_user_id = +this.to_user_id
            }
            Interface.getData('post', Interface.comment, params).then(res => {
                if (res.code == 0) {
                    this.$toast.success('评论成功')
                    this.comment_text = ''
                    this.comment_placeholder = '写评论'
                    this.comment_id = 0
                    this.to_user_id = 0
                    this.fetch('comment')
                    this.goComment()
                    this.showActionMeme = false
                }
            })
        },
        pointLikeComment(item) {
            Interface.getData('get', Interface.pointLikeComment + item.id).then(res => {
                if (res.code == 0) {
                    item.isLike = !item.isLike
                    if (item.isLike) {
                        item.like_count += 1
                    } else {
                        item.like_count -= 1
                    }
                }
            })
        },
        pointLike() {
            Interface.getData('get', Interface.short_video.point_like + this.id).then(res => {
                if (res.code == 0) {
                    this.course.isLike = !this.course.isLike
                    if (this.course.isLike) {
                        this.course.like_count += 1
                    } else {
                        this.course.like_count -= 1
                    }
                }
            })
        },
        openShareData() {
            this.showShareDialog = true
        },
        checkUserLogin() {
            this.userLoginCheck()
        }
    },
    created() {
        this.id = this.$route.params.id
        if (this.$route.query.content_type) {
            this.content_type = this.$route.query.content_type
        }
        this.fetch('course')
        this.fetch('comment')
        this.fetch('footprint')
        this.fetch('share')
    },
    watch: {
        async $route(to, from) {
            this.loading = true
            this.id = this.$route.params.id
            window.location.reload()
        }
    },
    destroyed() {
        if (this.myPlayer) {
            this.myPlayer.dispose()
        }
    }
}
</script>

<style lang="scss">
@import './index.scss';
</style>



// WEBPACK FOOTER //
// src/views/video/detail/index.vue